import { defineComponent as _defineComponent } from 'vue'
import { useBanksModel } from './../index'
import { IBanksItem } from './../model/types'
import { Cookie, amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { useCustomLogicModel } from '@shared/model'


export default /*#__PURE__*/_defineComponent({
  __name: 'BanksFavorite',
  emits: ['onClick'],
  setup(__props, { emit: emits }) {

const banksModel = useBanksModel()
const customLogicModel = useCustomLogicModel()



const onClick = (val: IBanksItem) => {
  amplitudeLogEvent(amplitudeEvents.CHOICE_BANK, { Банк: val.name })

  Cookie.set('selectedBankID', String(val.id), 365)
  banksModel.resortBanks()
  emits('onClick', val)
}

return { __sfc: true,banksModel, customLogicModel, emits, onClick }
}

})